/**
 * Shows/hides the "back to top" button based on scroll position, and scrolls smoothly to the
 * top of the page when clicked.
 * @returns {void}
 */
function initScrollTopButton() {
    const buttonScrollTop = document.querySelector('.scroll-top');

    window.addEventListener('scroll', () => {
        buttonScrollTop.classList.toggle('active', window.pageYOffset >= 600);
    }, { passive: true });

    buttonScrollTop.addEventListener('click', () => {
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    });
}

initScrollTopButton();
